import React, { FC, useEffect } from "react";

import "../styles.scss";
import "../scripts";

import {
  primaryBlock,
  PrimaryBlockConfig,
  KameleonElement,
  SecondaryBlockSize,
  TertiaryBlockSize,
  BlockTheme,
  getDefaultProps,
} from "@kameleon-core/lib";
import { Variants } from "@kameleon-util/global-theme";
import { Box } from "theme-ui";

import { WebflowComponentProps, webflowHOC } from "@kameleon-common/webflow-js";
import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";

import { getLogosToRender, renderLogos } from "./components/render-logos";
import { MediaCollectionType, layoutOptions } from "./types/prop-types";
import getEvents from "./js/webflow";

const durationTemplate = 3750;
const xValueTemplate = -14;

/** MediaCollection Primary */
const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.None,
  tertiaryBlockSize: TertiaryBlockSize.None,
  blockTheme: BlockTheme.light,
};

type PassThroughProps = {
  duration: number;
  xValue: number;
};
type CollectionWebflowType = WebflowComponentProps<
  MediaCollectionType,
  PassThroughProps
>;

const MediaCollectionComponent: FC<CollectionWebflowType> = ({
  title,
  logos,
  layoutProps,
  passThrough,
}) => {
  useEffect(() => {
    const logoSizeToRender = getLogosToRender(logos).length;
    passThrough?.({
      xValue: xValueTemplate * logoSizeToRender,
      duration: durationTemplate * logoSizeToRender,
    });
  }, [logos]);

  const logosToRender = logos && renderLogos(logos, layoutProps);
  return (
    <Box
      data-w-id="4cbc54d1-1780-5221-0930-af213f8b2a13"
      className="primary-media-collection-animated-row-small-media-v1 section_logo3"
    >
      <Box sx={{ overflow: "hidden" }} className="padding-section-medium">
        {title && (
          <Box className="padding-global container-large margin-bottom margin-large">
            <Box className="max-width-large inline-block">
              <Variants.Heading as="h2" variant="h6">
                {title}
              </Variants.Heading>
            </Box>
          </Box>
        )}
        <Box className="logo3_component">
          {logosToRender}
          {logosToRender}
        </Box>
      </Box>
    </Box>
  );
};

const ComponentWithWebflow = webflowHOC<
  CollectionWebflowType,
  PassThroughProps
>(MediaCollectionComponent, [
  {
    module: "ix2",
    getEvents: (pageId: any, passThrough): any =>
      getEvents(pageId, passThrough?.duration, passThrough?.xValue),
  },
]);

export const MediaCollection = primaryBlock<MediaCollectionType>(
  blockConfig,
  ComponentWithWebflow
);
MediaCollection.defaultProps = getDefaultProps<MediaCollectionType>(defaults);

export const Element: KameleonElement = {
  component: MediaCollection,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
